import { useCallManager } from 'contexts/call_manager_context'
import { useParticipantManager } from 'contexts/participant_manager_context'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { makeGetParticipantsGroupedByStatus } from 'reduxes/slices/call_participants/selectors'
import { Participant } from 'twilio-video'

export const useActiveCallContacts = () => {
  const {
    activeCall: { isOnCall, callRecord },
  } = useCallManager()

  const { localParticipant, remoteParticipants } = useParticipantManager()

  const allTwilioParticipants = useMemo(() => {
    const participants =
      remoteParticipants?.reduce(
        (acc: { [id: string]: Participant }, p: Participant) => {
          acc[p.identity] = p
          return acc
        },
        {},
      ) || {}

    if (localParticipant?.identity) {
      participants[localParticipant.identity] = localParticipant
    }

    return participants
  }, [localParticipant, remoteParticipants])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getParticipantsGroupedByStatus: any = useMemo(
    makeGetParticipantsGroupedByStatus,
    [],
  )
  const { onCall, notOnCall } = useSelector((state) =>
    getParticipantsGroupedByStatus(state, callRecord),
  )

  return {
    isOnCall,
    onCall,
    notOnCall,
    allTwilioParticipants,
  }
}
